import { Select, Radio, Space } from 'antd';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DEAL_SUBMISSION_MATCH_STATUS_TITLES } from '@zorba-shared/core/Constants/offer';

import { BUTTON_VARIANT_DARK } from '../../../../../../../components/forms/ZorbaButton/constants';
import { ZorbaButton } from '../../../../../../../components/forms';
import { setAppliedFilters } from '../../../../../../../reducers/Offer/actions';

import { options } from '../constants';

import '../index.scss';

export const StatusBuilder = ({ onApplyFilter }) => {
  const dispatch = useDispatch();
  const { appliedFilters } = useSelector(({ OfferReducer }) => OfferReducer);
  const [defaultRadioValue] = Object.keys(appliedFilters.status ?? {});
  const defaultSelectValue = defaultRadioValue
    ? appliedFilters.status[defaultRadioValue]
    : [];

  const [radioValue, setRadioValue] = useState(defaultRadioValue);
  const [selectedStatuses, setSelectedStatuses] = useState(defaultSelectValue);
  const statusOptions = Object.keys(DEAL_SUBMISSION_MATCH_STATUS_TITLES).map(
    (key) => ({
      label: DEAL_SUBMISSION_MATCH_STATUS_TITLES[key],
      value: key,
    }),
  );
  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleSelectChange = (newValue) => {
    setSelectedStatuses(newValue);
  };

  const isApplyButtonDisabled = !radioValue || !selectedStatuses.length;
  const handleApply = () => {
    dispatch(
      setAppliedFilters('status', {
        [radioValue]: selectedStatuses,
      }),
    );
    onApplyFilter();
  };

  return (
    <div className="builder-container">
      <h3>Status</h3>
      <div className="options-container">
        <Radio.Group onChange={handleRadioChange} value={radioValue}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={uuid()} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
        {radioValue && (
          <Select
            mode="tags"
            className="select"
            placeholder="Select Statuses"
            onChange={(newValue) => handleSelectChange(newValue)}
            value={selectedStatuses}
            options={statusOptions}
          />
        )}
      </div>
      <ZorbaButton
        variant={BUTTON_VARIANT_DARK}
        disabled={isApplyButtonDisabled}
        onClick={handleApply}
        fullWidth={false}
      >
        Apply
      </ZorbaButton>
    </div>
  );
};
